<template>
	<div>
		<el-form-item label="审核类型">
			<el-select v-model="userTaskForm.type" placeholder="请选择" @change="updateDataType">
				<el-option value="assignee" label="指定人"></el-option>
				<el-option value="candidateUsers" label="用户"></el-option>
				<el-option value="candidateRole" label="角色"></el-option>
				<el-option value="candidatePost" label="岗位"></el-option>
				<el-option value="candidateDept" label="机构"></el-option>
				<el-option value="deptLeader" label="机构领导"></el-option>
				<el-option value="startUserId" label="发起人"></el-option>
				<el-option value="variable" label="变量"></el-option>
			</el-select>
		</el-form-item>
		<el-form-item v-if="userTaskForm.type === 'assignee'" label="选择用户">
			<ma-user-input v-model="userTaskForm.assignee" @select="assigneeSelect" />
		</el-form-item>
		<el-form-item v-if="userTaskForm.type === 'candidateUsers'" label="选择用户">
			<ma-user-input v-model="userTaskForm.candidateUsers" multiple @select="candidateUsersSelect" />
		</el-form-item>
		<el-form-item v-if="userTaskForm.type === 'candidateRole'" label="选择角色">
			<ma-role-input v-model="userTaskForm.candidateGroups" multiple @select="roleGroupSelect" />
		</el-form-item>
		<el-form-item v-if="userTaskForm.type === 'candidatePost'" label="选择岗位">
			<ma-post-input v-model="userTaskForm.candidateGroups" multiple @select="postGroupSelect" />
		</el-form-item>
		<el-form-item v-if="userTaskForm.type === 'candidateDept'" label="选择机构">
			<ma-org-input v-model="userTaskForm.candidateGroups" multiple @select="candidateGroupsSelect" />
		</el-form-item>
		<el-form-item v-if="userTaskForm.type === 'variable'" label="变量">
			<el-input v-model="userTaskForm.variable" @blur="updateVariable"> </el-input>
		</el-form-item>

		<el-form-item
			v-if="
				userTaskForm.type === 'candidateUsers' ||
				userTaskForm.type === 'candidatePost' ||
				userTaskForm.type === 'candidateRole' ||
				userTaskForm.type === 'candidateDept'
			"
			label="多人会签"
		>
			<el-select v-model="loopCharacteristics" clearable placeholder="非会签" @change="changeMultiInstance">
				<el-option label="非会签" value="" />
				<el-option label="并行会签" value="ParallelMultiInstance" />
				<el-option label="串行会签" value="SequentialMultiInstance" />
			</el-select>
		</el-form-item>
		<el-form-item v-if="loopCharacteristics" label="完成条件">
			<el-slider
				v-model="multiCompleted"
				:min="1"
				:max="100"
				show-input
				:format-tooltip="
					val => {
						return val + '%'
					}
				"
				@change="updateLoopCondition"
			/>
		</el-form-item>
	</div>
</template>

<script>
import { Search } from '@element-plus/icons-vue'
import { nextTick } from 'vue'
import lodash from 'lodash'
export default {
	name: 'UserTask',
	props: {
		id: String,
		type: String,
		businessObject: Object
	},
	data() {
		return {
			visibleSelect: false,
			visibleRole: false,
			visiblePost: false,
			visibleDept: false,
			userQuery: {},
			loopCharacteristics: '',
			multiInstance: '',
			multiCompleted: 100,
			defaultTaskForm: {
				assignee: '',
				candidateUsers: [],
				candidateGroups: [],
				dueDate: '',
				followUpDate: '',
				priority: ''
			},
			userTaskForm: {
				type: 'assignee',
				variable: ''
			}
		}
	},
	watch: {
		id: {
			immediate: true,
			handler() {
				this.bpmnElement = window.bpmnInstances.bpmnElement
				this.$nextTick(() => this.resetTaskForm())
			}
		},
		businessObject: {
			immediate: true,
			handler(val) {
				this.bpmnElement = window.bpmnInstances.bpmnElement
				this.getElementLoop(val)
			}
		}
	},
	beforeUnmount() {
		this.bpmnElement = null
	},
	methods: {
		getElementLoop(businessObject) {
			if (!businessObject.loopCharacteristics) {
				return
			}

			const completionCondition = lodash.get(businessObject.loopCharacteristics, 'completionCondition.body', '')
			if (completionCondition) {
				const rateMatch = completionCondition.match(/\d+\.\d+/g)
				if (rateMatch) {
					this.multiCompleted = lodash.round(lodash.multiply(100, rateMatch[0]))
				} else {
					this.multiCompleted = 100
				}
			}

			if (businessObject.loopCharacteristics.isSequential) {
				this.loopCharacteristics = 'SequentialMultiInstance'
			} else {
				this.loopCharacteristics = 'ParallelMultiInstance'
			}

			this.multiLoopInstance = window.bpmnInstances.bpmnElement.businessObject.loopCharacteristics
		},
		Search() {
			return Search
		},
		changeMultiInstance() {
			if (!this.loopCharacteristics) {
				window.bpmnInstances.modeling.updateProperties(this.bpmnElement, { loopCharacteristics: null })
				return
			}

			const completionCondition = window.bpmnInstances.moddle.create('bpmn:FormalExpression', {
				body: '${nrOfCompletedInstances/nrOfInstances >= 1 }'
			})

			if (this.loopCharacteristics === 'ParallelMultiInstance') {
				this.multiLoopInstance = window.bpmnInstances.moddle.create('bpmn:MultiInstanceLoopCharacteristics', {
					completionCondition: completionCondition,
					collection: '${multiInstanceHandler.getList(execution)}',
					elementVariable: 'assignee'
				})
			} else {
				this.multiLoopInstance = window.bpmnInstances.moddle.create('bpmn:MultiInstanceLoopCharacteristics', {
					isSequential: true,
					completionCondition: completionCondition,
					collection: '${multiInstanceHandler.getList(execution)}',
					elementVariable: 'assignee'
				})
			}

			window.bpmnInstances.modeling.updateProperties(this.bpmnElement, {
				loopCharacteristics: this.multiLoopInstance
			})

			const taskAttr = Object.create(null)
			taskAttr['assignee'] = '${assignee}'
			window.bpmnInstances.modeling.updateProperties(this.bpmnElement, taskAttr)
		},
		updateLoopCondition() {
			const completionCondition = window.bpmnInstances.moddle.create('bpmn:FormalExpression', {
				body: '${nrOfCompletedInstances/nrOfInstances >= ' + lodash.multiply(this.multiCompleted, 0.01) + ' }'
			})
			window.bpmnInstances.modeling.updateModdleProperties(this.bpmnElement, this.multiLoopInstance, {
				completionCondition
			})
		},
		assigneeSelect(users) {
			nextTick(() => {
				this.userTaskForm.assigneeName = users[0].realName
				this.userTaskForm.assignee = users[0].id
				this.updateAssignee('assignee')
			})
		},
		candidateUsersSelect(users) {
			nextTick(() => {
				const candidateUsersName = []
				this.userTaskForm.candidateUsers = []
				for (const user of users) {
					candidateUsersName.push(user.realName)
					this.userTaskForm.candidateUsers.push(user.id)
				}
				this.userTaskForm.candidateUsersName = candidateUsersName.join(',')
				this.updateCandidateUsers('candidateUsers')
			})
		},
		candidateGroupsSelect(orgs) {
			nextTick(() => {
				const candidateGroupsName = []
				this.userTaskForm.candidateGroups = []
				for (const org of orgs) {
					candidateGroupsName.push(org.name)
					this.userTaskForm.candidateGroups.push(org.id)
				}
				this.userTaskForm.candidateGroupsName = candidateGroupsName.join(',')
				this.updateCandidateRole('candidateGroups')
			})
		},
		roleGroupSelect(roles) {
			nextTick(() => {
				const candidateGroupsName = []
				this.userTaskForm.candidateGroups = []
				for (const role of roles) {
					candidateGroupsName.push(role.name)
					this.userTaskForm.candidateGroups.push(role.id)
				}
				this.userTaskForm.candidateGroupsName = candidateGroupsName.join(',')
				this.updateCandidateRole('candidateGroups')
			})
		},
		postGroupSelect(posts) {
			this.visiblePost = true
			nextTick(() => {
				const candidateGroupsName = []
				this.userTaskForm.candidateGroups = []
				for (const post of posts) {
					candidateGroupsName.push(post.postName)
					this.userTaskForm.candidateGroups.push(post.id)
				}
				this.userTaskForm.candidateGroupsName = candidateGroupsName.join(',')
				this.updateCandidateRole('candidateGroups')
			})
		},
		cancelHandle() {
			console.log(22)
		},
		submitHandle() {
			console.log(22)
		},
		async resetTaskForm() {
			const assignee = this.bpmnElement?.businessObject['assignee']
			const candidateUsers = this.bpmnElement?.businessObject['candidateUsers']
			const candidateGroups = this.bpmnElement?.businessObject['candidateGroups']

			const dataType = this.bpmnElement?.businessObject.$attrs['flowable:dataType']
			const text = this.bpmnElement?.businessObject.$attrs['flowable:text']

			this.userTaskForm['assignee'] = ''
			this.userTaskForm['candidateUsers'] = []
			this.userTaskForm['candidateGroups'] = []

			this.userTaskForm.type = dataType

			if (dataType === 'assignee') {
				this.userTaskForm.assignee = assignee
				this.userTaskForm.assigneeName = text
				return
			}

			if (dataType === 'variable') {
				this.userTaskForm.variable = assignee
				return
			}

			if (dataType === 'candidateUsers') {
				this.userTaskForm.candidateUsers = candidateUsers?.split(',') || null
				this.userTaskForm.candidateUsersName = text

				return
			}

			if (dataType === 'candidateRole' || dataType === 'candidatePost' || dataType === 'candidateDept') {
				this.userTaskForm.candidateGroups = candidateGroups?.split(',') || null
				this.userTaskForm.candidateGroupsName = text
			}
		},
		updateAssignee(key) {
			const taskAttr = Object.create(null)
			taskAttr['candidateUsers'] = null
			taskAttr['candidateGroups'] = null
			taskAttr[key] = this.userTaskForm[key] || null
			taskAttr['flowable:dataType'] = 'assignee'
			taskAttr['flowable:text'] = this.userTaskForm['assigneeName'] || null

			window.bpmnInstances.modeling.updateProperties(this.bpmnElement, taskAttr)
		},
		updateVariable() {
			const taskAttr = Object.create(null)
			taskAttr['candidateUsers'] = null
			taskAttr['candidateGroups'] = null
			taskAttr['assignee'] = this.userTaskForm.variable

			window.bpmnInstances.modeling.updateProperties(this.bpmnElement, taskAttr)
		},
		updateCandidateUsers(key) {
			const taskAttr = Object.create(null)
			taskAttr['assignee'] = null
			taskAttr['candidateGroups'] = null
			taskAttr[key] = this.userTaskForm[key] && this.userTaskForm[key].length ? this.userTaskForm[key].join(',') : null
			taskAttr['flowable:text'] = this.userTaskForm['candidateUsersName'] || null

			window.bpmnInstances.modeling.updateProperties(this.bpmnElement, taskAttr)
		},
		updateCandidateRole(key) {
			const taskAttr = Object.create(null)
			taskAttr['assignee'] = null
			taskAttr['candidateUsers'] = null
			taskAttr[key] = this.userTaskForm[key] && this.userTaskForm[key].length ? this.userTaskForm[key].join(',') : null
			taskAttr['flowable:text'] = this.userTaskForm['candidateGroupsName'] || null

			window.bpmnInstances.modeling.updateProperties(this.bpmnElement, taskAttr)
		},
		updateDataType() {
			const type = this.userTaskForm.type
			const taskAttr = Object.create(null)
			taskAttr['candidateUsers'] = null
			taskAttr['candidateGroups'] = null
			taskAttr['assignee'] = null
			taskAttr['flowable:text'] = null

			if (type === 'deptLeader' || type === 'superDeptLeader') {
				this.userTaskForm.assigneeName = null
				taskAttr['loopCharacteristics'] = null
				this.loopCharacteristics = ''
			} else if (type === 'startUserId') {
				taskAttr['assignee'] = '${startUserId}'
				taskAttr['loopCharacteristics'] = null
				this.loopCharacteristics = ''
			} else if (type === 'variable') {
				taskAttr['assignee'] = this.userTaskForm.variable
				taskAttr['loopCharacteristics'] = null
				this.loopCharacteristics = ''
			} else if (type === 'assignee') {
				taskAttr['loopCharacteristics'] = null
				this.loopCharacteristics = ''
			}

			taskAttr['flowable:dataType'] = type
			window.bpmnInstances.modeling.updateProperties(this.bpmnElement, taskAttr)
		}
	}
}
</script>
